module.exports = __webpack_public_path__ + "img/schnittkante_lichtblau_ral5012.3dd6f5a0.jpg";